import { render, staticRenderFns } from "./ProfileAdminActions.vue?vue&type=template&id=7bd115e4&"
import script from "./ProfileAdminActions.vue?vue&type=script&lang=js&"
export * from "./ProfileAdminActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports